// Dati della scheda People di Projects V2: persone del progetto con ruolo e team, team e membri.
// Stesse API e stesse regole delle schede classiche Users e Teams (un utente sta in un solo team del progetto).
import { API_ENDPOINTS } from '../config/api.config';

async function request(url, options) {
  const res = await fetch(url, options);
  let body = null;
  try {
    body = await res.json();
  } catch (e) {
    body = null;
  }
  if (!res.ok) throw new Error(body?.error || body?.message || `Request failed (${res.status})`);
  return body || {};
}

const jsonOptions = (method, payload) => ({
  method,
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(payload),
});

/** Persone del progetto, ruoli di progetto e team con i membri (caricati in parallelo). */
export async function fetchProjectPeople(projectId) {
  const [pu, pr, t] = await Promise.all([
    request(`${API_ENDPOINTS.PROJECT_USERS}?project_id=${projectId}`),
    request(API_ENDPOINTS.PROJECT_ROLES),
    request(`${API_ENDPOINTS.TEAMS}?project_id=${projectId}`),
  ]);
  const teams = await Promise.all(
    (t.teams || []).map((team) =>
      request(`${API_ENDPOINTS.TEAM_MEMBERS}/${team.id}/members`)
        .then((m) => ({ ...team, members: m.members || [] }))
        .catch(() => ({ ...team, members: [] })),
    ),
  );
  return { members: pu.project_users || [], roles: pr.project_roles || [], teams: teams.sort((a, b) => String(a.name).localeCompare(String(b.name))) };
}

// Tutti gli utenti (per aggiungere persone): servono solo all'apertura del pannello, si caricano una volta
let usersPromise = null;
export function fetchAllUsers() {
  if (!usersPromise) {
    usersPromise = request(API_ENDPOINTS.USERS).then((d) => d.users || []);
    usersPromise.catch(() => {
      usersPromise = null;
    });
  }
  return usersPromise;
}

export const addProjectMember = (projectId, userId, roleId) =>
  request(`${API_ENDPOINTS.PROJECT_USERS}?project_id=${projectId}`, jsonOptions('POST', { user_id: userId, project_role_id: roleId }));
export const updateMemberRole = (projectId, userId, roleId) =>
  request(`${API_ENDPOINTS.PROJECT_USERS}?project_id=${projectId}&user_id=${userId}`, jsonOptions('PUT', { project_role_id: roleId }));
export const removeProjectMember = (projectId, userId) =>
  request(`${API_ENDPOINTS.PROJECT_USERS}?project_id=${projectId}&user_id=${userId}`, { method: 'DELETE' });

export const createTeam = (projectId, data) => request(API_ENDPOINTS.TEAMS, jsonOptions('POST', { ...data, project_id: projectId }));
export const updateTeam = (team, data) => request(`${API_ENDPOINTS.TEAMS}?id=${team.id}`, jsonOptions('PUT', { ...data, project_id: team.project_id }));
export const deleteTeam = (teamId) => request(`${API_ENDPOINTS.TEAMS}?id=${teamId}`, { method: 'DELETE' });

export const addTeamMember = (teamId, userId) => request(`${API_ENDPOINTS.TEAM_MEMBERS}/${teamId}/members`, jsonOptions('POST', { user_id: userId }));
export const removeTeamMember = (teamId, userId) => request(`${API_ENDPOINTS.TEAM_MEMBERS}/${teamId}/members?user_id=${userId}`, { method: 'DELETE' });

/** Sposta una persona nel team scelto (o in nessun team): esce da quello attuale ed entra nel nuovo. */
export async function setMemberTeam(userId, fromTeamId, toTeamId) {
  if (String(fromTeamId ?? '') === String(toTeamId ?? '')) return;
  if (fromTeamId) await removeTeamMember(fromTeamId, userId);
  if (toTeamId) await addTeamMember(toTeamId, userId);
}
